import type Big from 'big.js';
import orderBy from 'lodash/orderBy';

import type { DateRange } from '@cast/shared-types';
import {
  WorkloadTrafficDestination,
  WorkloadTrafficDestinationHistory,
} from '@cast/types';
import { toBig } from '@cast/utils';

import { fillGaps as fillGapsFn, WithFilledGaps } from 'utils/metrics';

import { Datapoint } from './_types';
import { NetworkResourceType } from '../../_types';

export const sumResource = (
  type: NetworkResourceType,
  item?: Pick<WorkloadTrafficDestination<Big>, 'ingress' | 'egress'>
): number => {
  if (!item) {
    return 0;
  }

  if (type === NetworkResourceType.COSTS) {
    return toBig(item.egress?.interZoneCost?.toNumber() || 0)
      .add(item.ingress?.interZoneCost?.toNumber() || 0)
      .toNumber();
  } else {
    return toBig(item.egress?.interZoneBytes?.toNumber() || 0)
      .add(item.ingress?.interZoneBytes?.toNumber() || 0)
      .toNumber();
  }
};

export const mapToDatapoint = (
  type: NetworkResourceType,
  item: WorkloadTrafficDestinationHistory<Big>,
  index: number
): Datapoint => {
  const value = sumResource(type, item);
  return {
    timestamp: item.timestamp!,
    forecast: false,
    [('workload' + index) as keyof Datapoint]: value,
  };
};

export const fillGaps = (
  [from, to]: DateRange,
  items: Datapoint[],
  order: 'asc' | 'desc' = 'asc'
): WithFilledGaps<Datapoint>[] => {
  const result = fillGapsFn({
    timeSeries: items,
    dateRange: { from, to },
    filler: {
      forecast: false,
      workload1: null,
      workload2: null,
      workload3: null,
      workload4: null,
      workload5: null,
    },
    fillPartial: true,
    unit: 'day',
  });

  return orderBy(result, ['timestamp'], [order]);
};
